import React from 'react'
import { Link } from 'react-router-dom'

export default () => (
  <nav>
    <Link to="/">Grocery list</Link>
    <Link to="/add-products">Add products</Link>
  </nav>
)